import { units } from '@ui/css';
import { CrossIcon, RoundedCheckmarkIcon } from '@ui/kit/icons';
import { stateIcon } from './atom.state-icon.style.js';
import { jsx } from 'react/jsx-runtime';

function StateIcon(props) {
  const stateIcon$1 = (() => {
    switch (props.state) {
      case "correct":
        return /*#__PURE__*/jsx(RoundedCheckmarkIcon, {
          style: {
            height: units.px(props.size === "thin" ? 13 : 18)
          },
          strokeWidth: 1.5
        });
      case "incorrect":
        return /*#__PURE__*/jsx(CrossIcon, {
          strokeWidth: 1,
          style: {
            height: units.px(props.size === "thin" ? 10 : 16)
          }
        });
    }
  })();
  if (!stateIcon$1) {
    return null;
  }
  return /*#__PURE__*/jsx("span", {
    className: stateIcon,
    "data-size": props.size,
    children: stateIcon$1
  });
}

export { StateIcon };
//# sourceMappingURL=atom.state-icon.js.map
